const LISTE_EXPEDITIONS = {
  title: 'Liste des expéditions',
  breadcrumb: {
    racine: 'Accueil',
    expeditions: 'Liste des expéditions',
  },
  actions: {
    search: 'Recherche',
    editionMasse: 'Générer édition',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    code: 'Code(s)',
    date: 'Date',
    etat: 'Etat(s)',
    lieuLivraison: 'Lieu(x) de livraison',
    dispositif: 'Dispositif(s)',
    typeOt: 'Type(s) OT',
    campagne: 'Campagne(s)',
    typeMateriel: 'Type(s) de matériel',
    enseigne: 'Enseigne(s)',
  },
  table: {
    nom: 'Lieu de livraison',
    adresse: 'Adresse',
    quantite: 'Quantité à expédier',
    nbOt: 'Nombre d\'OT',
    expedie: 'Expédier',
    childRow: {
      code: 'Code OT',
      type: 'Type',
      etat: 'Etat',
      site: 'Nom du site',
      quantite: 'Quantité à expédier',
      expedie: 'Expédier',
    },
  },
  popup: {
    msgExpedieOt: 'Êtes-vous sûr de vouloir mettre l\'état à "expédié" vos ordres de travail ?',
  },
  messages: {
    success: {
      otExpedie: 'Ordres de travail technique expédiés avec succès',
    },
  },
};

export const POP_UP_CHANGER_ETAT_EXPEDITION = {
  title: 'Gestion des expéditions',
  adresseExpedition: 'Adresse d\'expédition',
  adresseExpediteur: 'Adresse de l\'expéditeur',
  dateExpedition: 'Date d\'expédition',
  nombreElementColis: 'Nombre d\'élément du colis',
  poidsParColis: 'Poids par colis (kg)',
  contactDestination: 'Contact de destination',
  contactExpediteur: 'Contact de l\'expéditeur',
  instructionDeLivraison: 'Instruction de livraison',
  msgActionSuccess: 'L\'action a été effectuée avec succès',
  msgErreurMemeLieuExpedition: 'Tous les éléments sélectionnés doivent être vers le même lieu d\'expédition',
  errorFeild: {
    adresseExpeditionVille: 'La ville dans l\'adresse d\'expédition',
    adresseExpeditionCodePostal: 'Le code postal dans l\'adresse d\'expédition',
    adresseExpediteurVille: 'La ville dans l\'adresse de l\'expéditeur',
    adresseExpediteurCodePostal: 'Le code postal dans l\'adresse de l\'expéditeur',
    adresseExpeditionIntitule: 'L\'intitulé dans l\'adresse d\'expédition',
    adresseExpediteurIntitule: 'L\'intitulé dans l\'adresse de l\'expéditeur',
  },
};

export default LISTE_EXPEDITIONS;
